import { AssistanceService } from "@/service/services/Assistance.service";
import { CostCenterService } from "@/service/services/CostCenter.service";
import { ProfileService } from "@/service/services/Profile.service";
import { Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalProfileDelete.type";

export const ModalProfileDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, profile, onListProfiles, clearState } = props;
    const [loading, setLoading] = useState<boolean>(false);

    const onDeleted= async()=>{
        setLoading(true);
        await ProfileService.deleteProfile(profile.id).then((data) => {
            onListProfiles && onListProfiles();
            closeModal && closeModal();
        })
        setLoading(false);
    }
  
  return (
    <>
    <Modal
      open={open}
      handleClose={closeModal}
      size="xs"
    >
      <ModalHeader
        text="ELIMINAR PERFIL"
        className='positionElements'
        onCancel={closeModal}
        clearState={clearState}
      >
      </ModalHeader>

      <ModalBody>
        <Typography variant="subtitle1" className="textColor"> 
          ¿Está seguro de eliminar este Perfil?
        </Typography>
      </ModalBody>

      <ModalFooter 
        confirmText="Eliminar"
        cancelText="CANCELAR"
        onCancel={closeModal}
        className="footerRight"
        onConfirm={onDeleted}
        clearState={clearState}
      />
    </Modal>
    </>
  )
}